// @flow
/**
 * sendRAT
 * https://confluence.rakuten-it.com/confluence/display/COED/01-01.+Tracking+information+-+Campaign+In-Page+Survey
 */
import {
  TOAST_STATE_ASK,
  TOAST_STATE_NPS,
  TOAST_STATE_FORM,
  TOAST_STATE_FORM_AGREE,
  TOAST_STATE_FORM_DISAGREE,
  TOAST_STATE_COMPLETED,
  TOAST_STATE_DECLINED,
} from '../states.js';

export const RAT_ACCOUNT_ID_FOR_REX = '1253';

export const SCREEN = {
  TOAST: 'toast',
  NPS: 'nps',
  FORM: 'form',
  FORM_AGREE: 'form_agree',
  FORM_DISAGREE: 'form_disagree',
  THANKYOU: 'thankyou',
};

export const ACTION = {
  APPEAR: 'appear',
  CLOSE: 'close',
  AGREE: 'agree',
  DISAGREE: 'disagree',
  ANSWER: 'answer',
  DECLINE: 'decline',
};

export const isRATAvailable = () =>
  typeof window !== 'undefined' &&
  window.RAT &&
  typeof window.RAT.addCustomEvent === 'function';

export const getRatAccountId = (): ?string => {
  const input = document.getElementById('ratAccountId');
  if (input && input instanceof HTMLInputElement && input.value) {
    return input.value;
  }
  return null;
};

export const getScreenNameByToastState = (toastState: string): ?string => {
  let screen;
  if (toastState === TOAST_STATE_ASK) {
    screen = SCREEN.TOAST;
  } else if (toastState === TOAST_STATE_NPS) {
    screen = SCREEN.NPS;
  } else if (toastState === TOAST_STATE_FORM) {
    screen = SCREEN.FORM;
  } else if (toastState === TOAST_STATE_FORM_AGREE) {
    screen = SCREEN.FORM_AGREE;
  } else if (toastState === TOAST_STATE_FORM_DISAGREE) {
    screen = SCREEN.FORM_DISAGREE;
  } else if (toastState === TOAST_STATE_DECLINED) {
    screen = SCREEN.THANKYOU;
  } else if (toastState === TOAST_STATE_COMPLETED) {
    screen = SCREEN.THANKYOU;
  }
  return screen;
};

/**
 * sendRAT
 */
const sendRAT = ({
  cId,
  screen,
  action,
}: {
  cId: string,
  screen: string,
  action: string,
}) => {
  if (isRATAvailable()) {
    const ratConfig = {
      accountId: RAT_ACCOUNT_ID_FOR_REX,
      serviceId: 1,
      includeInput: true,
      pData: {
        compid: [`${screen}`, `${action}`],
      },
      cpData: {
        campaign_acc: getRatAccountId(),
        campaign_id: cId,
        campaign_solution: 'in_page_survey',
      },
      options: ['url', 'ua'],
      eventType: 'async',
    };

    try {
      RAT.addCustomEvent(ratConfig);
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
};

export default sendRAT;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/sendRAT.js